/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-mobile-table__select {
  padding: 0 25px 20px;
  width: 100%;
}

.ux-mobile-table__accordion {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: 15px;
  margin: 0 0 10px;
}
.ux-mobile-table__accordion-title {
  color: #131313 !important;
}
.ux-mobile-table__accordion span {
  display: block;
  white-space: normal;
  text-align: left;
}
.ux-mobile-table__accordion .ux-accordion__content-container {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.ux-mobile-table__accordion .ux-accordion__title-container {
  background-color: #c3cfd6;
  border-bottom: 1px solid #9ea9b0;
}
.ux-mobile-table__accordion .ux-accordion__title-container ux-icon[name=chevron-down] {
  padding: 0 0 0 10px;
}
.ux-mobile-table__accordion .ux-accordion__title-container ux-icon[name=square-info] {
  padding-bottom: 2px;
}
.ux-mobile-table__accordion-table {
  margin: 0 !important;
  width: 100% !important;
}
.ux-mobile-table__accordion-row {
  border-bottom: 1px solid #cbcbcb;
  display: block;
  padding: 20px 15px;
}
.ux-mobile-table__accordion-row:last-of-type {
  border-bottom: 0;
}
.ux-mobile-table__accordion .ux-button {
  margin: 20px 0;
}
.ux-mobile-table__accordion .ux-table__icon-text ux-icon {
  font-size: 26px;
  margin-left: 0;
}